import { isWhitelistedEmail } from '@mercadoni/sinister/dist/cjs/shared/utils';

const hasSponsored = ({ clientConfig = {} }) => {
  const { monitor = {}, sponsoredTag = {} } = clientConfig;
  const enableByConfig = monitor?.beacon?.isEnabled && sponsoredTag?.enabled;
  const enableByCookie = window.getCookie?.('_IL-sponsored-products') === '1'; // YR check
  const enableByFriendsNFamily = isWhitelistedEmail('sponsoredProducts');
  return enableByFriendsNFamily || enableByCookie || enableByConfig;
};

export const enableBeacon = ({ beacon = {} }) => {
  const enableByConfig = beacon?.isEnabled;
  const enableByCookie = window.getCookie?.('_IL-sponsored-products') === '1';// YR check
  const enableByFriendsNFamily = isWhitelistedEmail('sponsoredProducts');
  return enableByFriendsNFamily || enableByCookie || enableByConfig;
};

const sponsoredTagObj = ({ clientConfig }) => {
  return {
    ...clientConfig.sponsoredTag,
    enabled: hasSponsored({ clientConfig }),
  };
};

const hasOnClickBeaconAttribute = ({ promoted }) =>
  promoted && promoted?.onClickBeacon;

const hasOnLoadBeaconAttribute = ({ promoted }) =>
  promoted && promoted?.onLoadBeacon;

const hasOnBasketChangeBeaconAttribute = ({ promoted }) =>
  promoted && promoted?.onBasketChangeBeacon;

const beaconAttribute = product =>
  (hasOnLoadBeaconAttribute(product) && {
    'data-criteo-product-onloadbeacon': product.promoted?.onLoadBeacon,
    'data-criteo-product-onviewbeacon': product.promoted?.onViewBeacon,
  }) ||
  {};

export {
  beaconAttribute,
  hasOnBasketChangeBeaconAttribute,
  hasOnClickBeaconAttribute,
  hasOnLoadBeaconAttribute,
  hasSponsored,
  sponsoredTagObj
};

